// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// ANTD
import Form from 'antd/lib/form';
import Button from 'components/common/Button';
import Row from 'components/common/Row';
import Col from 'components/common/Col';

// COMPONENTS
import ContractTypeInput from 'components/inputs/ContractTypeInput';
import FormItem from 'components/common/FormItem';
import ClientInput from 'components/inputs/ClientInput';
// APOLLO
import { graphql, compose } from 'react-apollo';
import getClientsFormQuery from 'ApolloClient/Queries/getClientsForm';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';

// STYLE-COMPONENTS
// ============================

const Container = styled.div`
  min-height: 180px;
  width: 300px;
  max-width: 100%;
`;

const LoadingContainer = styled.div`
  min-height: 200px;
  align-items: center;
  justify-content: center;
  display: flex;
  height: 100%;
`;

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 10px;
`;

// This component only renders the Session form, all the logic must be handled
// in the parent component.
class CreateContractForm extends React.Component {
  state = {
    contractType: this.props.contractType || null,
    clientId: this.props.clientId || null,
  };

  handleSubmit = evt => {
    // const { onBeforeHook, onErrorHook, onSubmitHook, form } = this.props;
    evt.preventDefault();
    this.props.onSubmitHook(this.state);
    // // Run before logic if provided and return on error
    // try {
    //   onBeforeHook();
    // } catch (exc) {
    //   return; // return silently
    // }
    // form.validateFields((err, contract) => {
    //   if (err) {
    //     // Pass event up to parent component
    //     onErrorHook(err);
    //   } else {
    //     // Pass lineItem values to parent component to handle submit functionality
    //     onSubmitHook(contract);
    //   }
    // });
  };

  onChange = newValue => {
    this.setState(newValue);
  };

  render() {
    const { btnLabel, hideClientInput } = this.props;

    return (
      <Container>
        <Form layout="vertical" onSubmit={this.handleSubmit} style={{ width: '100%' }}>
          <Row gutter={15}>
            <Col xs={24} className={hideClientInput ? 'display-none' : ''}>
              <FormItem>
                <label>Client</label>
                <ClientInput
                  onChange={clientId => this.onChange({ clientId })}
                  value={this.state.clientId}
                  data={this.props.getClientsFormQuery}
                />
              </FormItem>
            </Col>
            <Col xs={24}>
              <FormItem>
                <label>Select Your Contract Type</label>
                <ContractTypeInput
                  value={this.state.contractType}
                  onChange={contractType => this.onChange({ contractType })}
                />
              </FormItem>
            </Col>
          </Row>
          <ButtonContainer>
            <Button
              htmlType="submit"
              // disabled={this.props.loading || !getFieldValue('contractType') || !getFieldValue('clientId')}
              loading={this.props.loading}
              onSubmit={this.handleSubmit}
              style={{ width: '100%' }}
            >
              {btnLabel}
            </Button>
          </ButtonContainer>
        </Form>
      </Container>
    );
  }
}

CreateContractForm.propTypes = {
  btnLabel: PropTypes.string,
  disabled: PropTypes.bool,
  hideClientInput: PropTypes.bool,
  onBeforeHook: PropTypes.func,
  onErrorHook: PropTypes.func,
  onSubmitHook: PropTypes.func,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func.isRequired,
  }).isRequired,
};

CreateContractForm.defaultProps = {
  btnLabel: 'SUBMIT',
  initialValue: null,
  disabled: false,
  hideClientInput: false,
  onBeforeHook: () => {},
  onErrorHook: () => {},
  onSubmitHook: () => {},
};

export default compose(
  graphql(getClientsFormQuery, { name: 'getClientsFormQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'getClientsFormQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'getClientsFormQuery' }),
)(CreateContractForm);



// WEBPACK FOOTER //
// ./src/components/forms/CreateContractForm/index.js